import { useGetApplication } from 'hooks/useGetApplication'
import './style.styl'

const PrivacyPolicy = () => {
  const { isAc } = useGetApplication()
  const link = isAc
    ? 'https://www.acordocerto.com.br/politicas-do-site'
    : 'https://consumidorpositivo.com.br/termos-e-politica'
    
  return (
    <p className="terms-conditions">
      Ao continuar, você concorda com os{' '}
      <a href={link} target="__blank">
        Termos de Uso e Política de Privacidade
      </a>
    </p>
  )
}

export default PrivacyPolicy
